import { Divider, Drawer, Input, Space, Alert, Checkbox, AutoComplete } from "antd";
import React, { useEffect, useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import BMInput from "../../comps/BMInput";
import { PicRightOutlined, PicLeftOutlined, PicCenterOutlined } from '@ant-design/icons';
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import { tt_name_block_warning } from "../../../utils/Utils";
import SliderInput from "../../UI/SiderInput";
import Html from "../../../utils/Html";

export default function ConstantContactEmbedded(props) {

    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;
    const [content, setContent] = useState(props.content);
    const [template,] = useTemplate();

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }



    // 434e5d6c5ec8ed6052a414658ec6db7d
    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        form_id = "",
        selected_form = "",
        background_colour = 0,
        contained = false,
        width = 1248,
        height = 400,
        align = "0 auto",
        padding_x = 10,
        padding_y = 10,
    } = data;




    const [forms, setForms] = useState([]);



    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const drawRender = () => {

        let _style = {
            padding: padding_y + "px " + padding_x + "px",
            background: getColor(background_colour, template)
        }

        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={_style} >
                    <div style={{ maxWidth: (contained) ? width + "px" : "100%", margin: align, }}>
                        {(!form_id && <>Needs Form ID</>)}
                        {(form_id &&
                            <Html html={`
                        <iframe
                            id="ccFormIframe"
                            data-ctct-m="${form_id}"
                            data-ctct-f="${selected_form}"
                            src="/create/cc.html"
                            width="100%"
                            height="${height}"
                            frameborder="0"
                            scrolling="yes">
                        </iframe>    
                        `} />
                        )}
                    </div>
                </div>
            </div>
        )
    }


    useEffect(() => {
        if (data.form_id.length === 32 && forms.length === 0) {
            fetch(`https://listgrowth.ctctcdn.com/v1/${form_id}.json`)
                .then(res => res.json())
                .then(data => {
                    setForms(data.forms.map(item => {
                        return {
                            value: item.form_id,
                            label: item.name,
                            
                        };
                    }))
                })
                .catch(err => console.error(err));
        }
    }, [data.form_id])


    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                <Alert type="info" style={{ "lineHeight": "14px" }} message={<small >To find your Constant Contact Universal Code, log into your account, navigate to <strong>Channels &gt; Sign-up Forms</strong>, click the three-dot menu for your desired sign-up form, and select <strong>View inline code</strong>, then click the <strong>View universal code.</strong></small>} />

                <div className="shim" /> <div className="shim" />
                {/* CONSTANT CONTACT FORM ID */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">CONSTANT CONTACT UNIVERSAL CODE</Divider>
                <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "form_id": e.target.value })} value={form_id} placeholder="Universal code..." />
                <div className="shim" /> <div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">FORM ID</Divider>
                <AutoComplete options={forms} style={{ "fontSize": "11px", "width" : "245px" }} onChange={(e) => setData({ ...data, "selected_form": e })} value={selected_form} placeholder="Form ID" />
                <div className="shim" /> <div className="shim" />

                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />

                {/* WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">WIDTH</Divider>
                <div className="float-flex">
                    <SliderInput
                        width={90}
                        min={0}
                        max={1248}
                        onChange={(_v) => setData({ ...data, "width": _v })}
                        disabled={!contained}
                        value={width}
                    />
                    <Checkbox onChange={(e) => setData({ ...data, "contained": e.target.checked })} checked={contained}><small>Constrain?</small></Checkbox>
                </div>
                <div className="shim" /> <div className="shim" />

                {/* HEIGHT */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEIGHT</Divider>
                <BMInput value={height} onChange={(_v) => setData({ ...data, "height": _v })} number min={100} max={1248} prefix="HEIGHT" />
                <div className="shim" /> <div className="shim" />

                {/* ALIGN / PADDING */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALIGN / PADDING</Divider>
                <div className="float-flex">
                    <Space>
                        <div><PicLeftOutlined onClick={() => setData({ ...data, "align": "0" })} style={{ "color": (align === "0") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicCenterOutlined onClick={() => setData({ ...data, "align": "0 auto" })} style={{ "color": (align === "0 auto") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicRightOutlined onClick={() => setData({ ...data, "align": "0 0 0 auto" })} style={{ "color": (align === "0 0 0 auto") ? "#1890ff" : "#AAA" }} /></div>
                    </Space>
                    <Space>
                        <BMInput value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<PaddingHorizontalIcon style={{ "color": "#888" }} />} />
                        <BMInput value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<PaddingVerticalIcon style={{ "color": "#888" }} />} />
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />
            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}